export const cleanObject = (obj) => {
  if (!obj) return null;
  const result = Object.fromEntries(
    Object.entries(obj).filter(
      // eslint-disable-next-line no-unused-vars
      ([_, value]) => value !== null && value !== undefined,
    ),
  );
  if (Object.keys(result)?.length > 0) return result;
  return null;
};
